import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import {SignoutCallbackComponent} from "redux-oidc";
import {withRouter} from 'react-router-dom';
import userManager from "../../userManager";
import { clearForm } from "../../redux/actions";

const Logout = props => {
  const dispatch = useDispatch();
  const form = useSelector(state => state.form);

  return <SignoutCallbackComponent
    userManager={userManager}
    successCallback={(response) => {
      debugger;
      console.log("process " + process.env.REACT_APP_LOGOUT_URL)
      dispatch(clearForm());
      window.location.href = `${process.env.REACT_APP_LOGOUT_URL}`
      //form.form === 'import-export' ? props.history.push('/import-export') : props.history.push('/flora-fauna');
    }}
    errorCallback={error => {
      console.error(error);
      dispatch(clearForm());
      form.form === 'import-export' ? props.history.push('/import-export') : props.history.push('/flora-fauna');
    }}
  >
    <div>Logging out...</div>
  </SignoutCallbackComponent>
}

export default withRouter(props => <Logout {...props}/>);
